import type { NextPage } from 'next';
import Head from 'next/head';
import ExpertiseComponent from '@components/expertise/expertise';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';

const Expertise: NextPage = () => {
    return (
        <>
            <Head>
                {
                    MetaTags({
                        title: 'Agilie’s Competence and Expertise',
                        description: 'Thrive with Agilie’s software expertise',
                        imageUrl: '/expertise-images/introduction-meta.png',
                    })
                }
                <link rel="icon" href="/favicon.ico"/>
            </Head>
            <MainLayout>
                <ExpertiseComponent/>
            </MainLayout>
        </>
    )
}

export default Expertise;
